module.exports.jmolColors = {
  H: [255, 255, 255],
  He: [217, 255, 255],
  Li: [204, 128, 255],
  Be: [194, 255, 0],
  B: [255, 181, 181],
  C: [144, 144, 144],
  N: [48, 80, 248],
  O: [255, 13, 13],
  F: [144, 224, 80],
  Ne: [179, 227, 245],
  Na: [171, 92, 242],
  Mg: [138, 255, 0],
  Al: [191, 166, 166],
  Si: [240, 200, 160],
  P: [255, 128, 0],
  S: [255, 255, 48],
  Cl: [31, 240, 31],
  Ar: [128, 209, 227],
  K: [143, 64, 212],
  Ca: [61, 255, 0],
  Sc: [230, 230, 230],
  Ti: [191, 194, 199],
  V: [166, 166, 171],
  Cr: [138, 153, 199],
  Mn: [156, 122, 199],
  Fe: [224, 102, 51],
  Co: [240, 144, 160],
  Ni: [80, 208, 80],
  Cu: [200, 128, 51],
  Zn: [125, 128, 176],
  Ga: [194, 143, 143],
  Ge: [102, 143, 143],
  As: [189, 128, 227],
  Se: [255, 161, 0],
  Br: [166, 41, 41],
  Kr: [92, 184, 209],
  Rb: [112, 46, 176],
  Sr: [0, 255, 0],
  Y: [148, 255, 255],
  Zr: [148, 224, 224],
  Nb: [115, 194, 201],
  Mo: [84, 181, 181],
  Tc: [59, 158, 158],
  Ru: [36, 143, 143],
  Rh: [10, 125, 140],
  Pd: [0, 105, 133],
  Ag: [192, 192, 192],
  Cd: [255, 217, 143],
  In: [166, 117, 115],
  Sn: [102, 128, 128],
  Sb: [158, 99, 181],
  Te: [212, 122, 0],
  I: [148, 0, 148],
  Xe: [66, 158, 176],
  Cs: [87, 23, 143],
  Ba: [0, 201, 0],
  La: [112, 212, 255],
  Ce: [255, 255, 199],
  Pr: [217, 255, 199],
  Nd: [199, 255, 199],
  Pm: [163, 255, 199],
  Sm: [143, 255, 199],
  Eu: [97, 255, 199],
  Gd: [69, 255, 199],
  Tb: [48, 255, 199],
  Dy: [31, 255, 199],
  Ho: [0, 255, 156],
  Er: [0, 230, 117],
  Tm: [0, 212, 82],
  Yb: [0, 191, 56],
  Lu: [0, 171, 36],
  Hf: [77, 194, 255],
  Ta: [77, 166, 255],
  W: [33, 148, 214],
  Re: [38, 125, 171],
  Os: [38, 102, 150],
  Ir: [23, 84, 135],
  Pt: [208, 208, 224],
  Au: [255, 209, 35],
  Hg: [184, 184, 208],
  Tl: [166, 84, 77],
  Pb: [87, 89, 97],
  Bi: [158, 79, 181],
  Po: [171, 92, 0],
  At: [117, 79, 69],
  Rn: [66, 130, 150],
  Fr: [66, 0, 102],
  Ra: [0, 125, 0],
  Ac: [112, 171, 250],
  Th: [0, 186, 255],
  Pa: [0, 161, 255],
  U: [0, 143, 255],
  Np: [0, 128, 255],
  Pu: [0, 107, 255],
  Am: [84, 92, 242],
  Cm: [120, 92, 227],
  Bk: [138, 79, 227],
  Cf: [161, 54, 212],
  Es: [179, 31, 212],
  Fm: [179, 31, 186],
  Md: [179, 13, 166],
  No: [189, 13, 135],
  Lr: [199, 0, 102],
  Rf: [204, 0, 89],
  Db: [209, 0, 79],
  Sg: [217, 0, 69],
  Bh: [224, 0, 56],
  Hs: [230, 0, 46],
  Mt: [235, 0, 38],
};

module.exports.covalentRadius = {
  H: "0.31",
  He: "0.28",
  Li: "1.28",
  Be: "0.96",
  B: "0.84",
  C: "0.76",
  N: "0.71",
  O: "0.66",
  F: "0.57",
  Ne: "0.58",
  Na: "1.66",
  Mg: "1.41",
  Al: "1.21",
  Si: "1.11",
  P: "1.07",
  S: "1.05",
  Cl: "1.02",
  Ar: "1.06",
  K: "2.03",
  Ca: "1.76",
  Sc: "1.7",
  Ti: "1.6",
  V: "1.53",
  Cr: "1.39",
  Mn: "1.39",
  Fe: "1.32",
  Co: "1.26",
  Ni: "1.24",
  Cu: "1.32",
  Zn: "1.22",
  Ga: "1.22",
  Ge: "1.2",
  As: "1.19",
  Se: "1.2",
  Br: "1.2",
  Kr: "1.16",
  Rb: "2.2",
  Sr: "1.95",
  Y: "1.9",
  Zr: "1.75",
  Nb: "1.64",
  Mo: "1.54",
  Tc: "1.47",
  Ru: "1.46",
  Rh: "1.42",
  Pd: "1.39",
  Ag: "1.45",
  Cd: "1.44",
  In: "1.42",
  Sn: "1.39",
  Sb: "1.39",
  Te: "1.38",
  I: "1.39",
  Xe: "1.4",
  Cs: "2.44",
  Ba: "2.15",
  La: "2.07",
  Ce: "2.04",
  Pr: "2.03",
  Nd: "2.01",
  Pm: "1.99",
  Sm: "1.98",
  Eu: "1.98",
  Gd: "1.96",
  Tb: "1.94",
  Dy: "1.92",
  Ho: "1.92",
  Er: "1.89",
  Tm: "1.9",
  Yb: "1.87",
  Lu: "1.87",
  Hf: "1.75",
  Ta: "1.7",
  W: "1.62",
  Re: "1.51",
  Os: "1.44",
  Ir: "1.41",
  Pt: "1.36",
  Au: "1.36",
  Hg: "1.32",
  Tl: "1.45",
  Pb: "1.46",
  Bi: "1.48",
  Po: "1.4",
  At: "1.5",
  Rn: "1.5",
  Fr: "2.6",
  Ra: "2.21",
  Ac: "2.15",
  Th: "2.06",
  Pa: "2.0",
  U: "1.96",
  Np: "1.9",
  Pu: "1.87",
  Am: "1.8",
  Cm: "1.69",
  Bk: "0.2",
  Cf: "0.2",
  Es: "0.2",
  Fm: "0.2",
  Md: "0.2",
  No: "0.2",
  Lr: "0.2",
  Rf: "0.2",
  Db: "0.2",
  Sg: "0.2",
  Bh: "0.2",
  Hs: "0.2",
  Mt: "0.2",
  Ds: "0.2",
  Rg: "0.2",
  Cn: "0.2",
  Nh: "0.2",
  Fl: "0.2",
  Mc: "0.2",
  Lv: "0.2",
  Ts: "0.2",
  Og: "0.2",
};
